import {
  ToggleButton,
  ToggleButtonGroup,
  styled,
  useTheme,
} from "@mui/material";
import { t } from "i18next";
import { EViewType } from "../../../pages/Home";
import GridViewRoundedIcon from "@mui/icons-material/GridViewRounded";
import ViewListRoundedIcon from "@mui/icons-material/ViewListRounded";

type Props = {
  value: EViewType;
  onChange: (value: EViewType) => void;
};

const ViewOptionsButton = (props: Props) => {
  const theme = useTheme();

  const CustomToggleButton = styled(ToggleButton)({
    background: theme.palette.base.main,
    color: theme.palette.base.contrast,
    "&.Mui-selected": {
      background: theme.palette.base.ymdBackground,
      color: "#FFFFFF",
    },
    "&.Mui-selected:hover": {
      background: theme.palette.base.ymdBackground,
      color: "#FFFFFF",
    },
  });

  return (
    <ToggleButtonGroup
      exclusive
      size="small"
      value={props.value}
      onChange={(e, v) => {
        if (v === null) return; // すでに選択されているものをもう一度クリックしたときは無視
        props.onChange(v);
      }}
      sx={{ height: "40px", borderRadius: "0px" }}
    >
      <CustomToggleButton
        value={EViewType.GRID}
        sx={{ minWidth: "40px", borderRadius: "0px" }}
      >
        <GridViewRoundedIcon />
      </CustomToggleButton>
      <CustomToggleButton
        value={EViewType.LIST}
        sx={{ minWidth: "40px", borderRadius: "0px" }}
      >
        <ViewListRoundedIcon />
      </CustomToggleButton>
    </ToggleButtonGroup>
  );
};

export default ViewOptionsButton;
